import { E } from '@angular/cdk/keycodes';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ExpressionEvaluator {

    private safeContext = {
        // Math functions
        Math: Math,
        // Date functions
        Date: Date,
        // String functions
        startsWith: (str: string, prefix: string) => str?.startsWith(prefix),
        includes: (arr: any[], item: any) => arr?.includes(item),
        // Comparison helpers
        eq: (a: any, b: any) => a == b,
        gt: (a: number, b: number) => a > b,
        gtEq: (a: number, b: number) => a >= b,
        lt: (a: number, b: number) => a < b,
        isNotNull: (val: any) => val !== null && val !== undefined
      };

      evaluate(expr: string, context: object): boolean {
        try {
          // Merge context with safe functions
          const fullContext = { ...context, ...this.safeContext };

          // Use bracket notation instead of 'with' for better security
          const evaluator = new Function('ctx', `
            try {
              return ${this.sanitizeExpression(expr)};
            } catch {
              return false;
            }
          `);

          return evaluator(fullContext);
        } catch {
          return false;
        }
      }

      private sanitizeExpression(expr: string): string {
        // Convert quoted booleans to real booleans
        expr = expr
          .replace(/'true'/g, 'true')
          .replace(/'false'/g, 'false');

        return expr
          .replace(/eq\(([^,]+),\s*([^)]+)\)/g, 'ctx.eq(ctx.$1, $2)')
          .replace(/gtEq\(([^,]+),\s*([^)]+)\)/g, 'ctx.gtEq(ctx.$1, $2)')
          .replace(/gt\(([^,]+),\s*([^)]+)\)/g, 'ctx.gt(ctx.$1, $2)')
          .replace(/lt\(([^,]+),\s*([^)]+)\)/g, 'ctx.lt(ctx.$1, $2)')
          .replace(/isNotNull\(([^)]+)\)/g, 'ctx.isNotNull(ctx.$1)');
      }
}
